export default "__VITE_ASSET__MeAiyzq6__"